import React from 'react'
import Modal from 'react-modal'
import {FormattedMessage, defineMessages, injectIntl} from 'react-intl'
import R from 'ramda'
import {connect} from 'react-redux'

import Spacer from './Spacer'
import Icon from './Icon'
import I18nSelect from './I18nSelect'

import onChange from '../actions/changePreferencesModal'
import onClose from '../actions/togglePreferencesModal'
import toggleTour from '../actions/toggleTour'
import langChange from '../actions/langChange'

import eventHandler from '../utils/eventHandler'

const m = defineMessages({
  m2: {
    id: 'meter2-symbol',
    defaultMessage: 'm\u00B2',
  },
  ft2: {
    id: 'feet2-symbol',
    defaultMessage: 'ft\u00B2'
  }
})


//TODO this style should be extracted into a css style
const customStyles = {
  content : {
    overflow: 'auto',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: "500px",
    height: "350px"
  },
  overlay: {
    zIndex: "1000"
  }
}

const PreferencesModal = ({isOpen, isTourVisible, lang, areaUnit, distanceUnit, currency, options, onClose, onApply, onChange, onLangChange, onToggleTour, intl}) => {
  const translatOption = option => ({
    name: intl.formatMessage(m[option.name]), 
    code: option.name
  })
  const translatedOptions = R.map(translatOption, options.areaUnits)
  
  return <Modal isOpen={isOpen}
        onRequestClose={onClose}
        style={customStyles}
        >
      <div className="modal-header">
        <button className="close" onClick={onClose}>
          <Icon name="times"></Icon>
        </button>
        <h4 className="modal-title">
          <FormattedMessage
            id="Preferences"
            defaultMessage="Preferences"/>
        </h4>
      </div>

      <div className="modal-body">
        <div style={{display:'flex', flexDirection: 'column', justifyContent:'space-between'}}>
          <form>
            
            <div className="form-group">
              <div className="checbox">
                <label>
                  <input type="checkbox" checked={isTourVisible} onChange={onToggleTour}/>
                  {' '}
                  <FormattedMessage id="Show tour" defaultMessage="Show tour"/>
                </label>
              </div>
            </div>

            <div className="form-group">
              <label>
                <FormattedMessage id="Lang" defaultMessage="Lang"/>
              </label>
              <I18nSelect labelKey='label'
                          valueKey='value'
                          options={options.langs}
                          value={lang}
                          onChange={onLangChange}
                          searchable={false}
                          clearable={false}                          
                          />
            </div>
          
            <div className="form-group">
              <label>
                <FormattedMessage id="Area" defaultMessage="Area"/>
              </label>
              <I18nSelect labelKey='name' 
                          valueKey='code' 
                          options={translatedOptions} 
                          value={areaUnit} 
                          onChange={onChange('areaUnit')} 
                          searchable={false} 
                          clearable={false}
                          />
            </div>
          </form>
        </div>
      </div>
    </Modal>
}

PreferencesModal.propTypes = {
  isOpen: React.PropTypes.bool.isRequired,
  isTourVisible: React.PropTypes.bool.isRequired,
  lang: React.PropTypes.string.isRequired,
  options: React.PropTypes.shape({
    langs: React.PropTypes.array.isRequired,
    areaUnits: React.PropTypes.array.isRequired,
    distanceUnits: React.PropTypes.array.isRequired,
    currencies: React.PropTypes.array.isRequired,
  }).isRequired,
  areaUnit: React.PropTypes.string.isRequired,
  distanceUnit: React.PropTypes.string.isRequired,
  currency: React.PropTypes.string.isRequired,

  onClose: React.PropTypes.func.isRequired,
  onLangChange: React.PropTypes.func.isRequired,
  onChange: React.PropTypes.func.isRequired,
  onToggleTour: React.PropTypes.func.isRequired,
}

const mapStateToProps = (state) => {
  return  {
    isTourVisible: !state.completedTours.search || !state.completedTours.preSearch,
    isOpen: state.show.preferencesModal,
    lang: state.lang,
    areaUnit: state.areaUnit,
    distanceUnit: state.distanceUnit,
    currency: state.currency,
    options: state.options
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onClose: _ => dispatch(onClose()),
    onChange: field => ({code}) => dispatch(onChange(field, code)),
    onLangChange: ({label, value}) => dispatch(langChange(value)),
    onToggleTour: _ => dispatch(toggleTour()),
  }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(PreferencesModal))



/** WEBPACK FOOTER **
 ** ./app/components/PreferencesModal.jsx
 **/